import { useEffect } from 'react';
import './AffiliatesPage.css';

const AffiliatesPage = () => {
  useEffect(() => {
    const script = document.createElement('script');
    script.src = 'https://server.fillout.com/embed/v1/';
    script.async = true;
    document.body.appendChild(script);
    return () => {
      if (document.body.contains(script)) {
        document.body.removeChild(script);
      }
    };
  }, []);

  return (
    <div className="affiliates-page">
      <section className="affiliates-hero">
        <h1 className="affiliates-title">Affiliate Program</h1>
        <p className="affiliates-subtitle">
          Partner with Oval and earn commissions by referring members to our
          telehealth and prescription savings platform. Fill out the form below
          to get started.
        </p>
      </section>

      <section className="affiliates-form-section">
        <div
          data-fillout-id="wtPVmZmZPHus"
          data-fillout-embed-type="standard"
          data-fillout-inherit-parameters
          data-fillout-dynamic-resize
          style={{ width: '100%', height: '500px' }}
        />
      </section>
    </div>
  );
};

export default AffiliatesPage;
